import React from 'react';

export function Divider() {
    return (
        <div className="ulx-divider-container">
            <div className="ulx-divider-container__divider" />
        </div>
    );
}

export default Divider;
